import mapData from '@highcharts/map-collection/custom/world.topo.json';

export const countriesExportingOrImporting = (props: any, key: string, text: string) => {
    const data: any[] = [];
    const countries = props.finalSubmissions.reduce((acc: {[key: string]: number}, submission: any) => {
        for (let i = 0; i <= 30; i++) {
            const answer = submission[`${key}_${i}`];

            if (!answer) continue;

            acc[answer] ? acc[answer]++ : (acc[answer] = 1);
        }

        return acc;
    }, {});

    for (const country in countries) {
        data.push({
            key: country,
            value: countries[country],
            visible: true
        })
    }

    return {
        chart: {
            map: mapData,
        },
        title: {
            text,
            align: 'left'
        },
        colorAxis: {
            min: 0,
            stops: [
                [0, '#EFEFFF'],
                [0.5, '#2caffe'],
                [1, 'rgb(0,48,127)']
            ]
        },
        accessibility: {
            series: {
                descriptionFormat: '{series.name}, map with {series.points.length} areas.',
                pointDescriptionEnabledThreshold: 50
            }
        },
        legend: {
            layout: 'vertical',
            align: 'left',
            verticalAlign: 'bottom'
        },
        plotOptions: {
            map: {
                joinBy: ['name', 'key'],
            }
        },
        series: [
            {
                name: 'Countries Importing',
                data
            }
        ]
    } as Highcharts.Options;
}